<template>
  <transition
    enter-active-class="animate__animated animate__fadeIn"
    leave-active-class="animate__animated animate__fadeOut"
  >
    <v-snackbar v-model="failure" :top="true" color="#dc3545" timeout="2500">
      {{ message }}
    </v-snackbar>
  </transition>
</template>
  
  <script>
export default {
  name: "FailureSnackbar",
  props: {
    message: {
      type: [String, Boolean, Error],
      required: true,
    },
  },
  data() {
    return {
      failure: true,
    };
  },
  methods: {
    updateVisibility() {
      this.failure = !this.failure;
      this.$emit("update-failure", this.failure);
    },
  },
  watch: {
    failure(val) {
      this.updateVisibility();
    },
  },
};
</script>